import { authFetch } from "@/lib/api-client";

export interface SystemSettings {
  clientPath: string;
  competitorsPath: string;
  updatedByName: string | null;
  updatedAt: string | null;
  revision: number;
}

export async function fetchSystemSettings(): Promise<SystemSettings> {
  const { data } = await authFetch<SystemSettings>("/admin/settings/system");
  return data;
}

export async function updateSystemSettings(input: {
  clientPath: string;
  competitorsPath: string;
  expectedRevision: number;
}): Promise<SystemSettings> {
  const { data } = await authFetch<SystemSettings>("/admin/settings/system", {
    method: "PUT",
    body: JSON.stringify(input),
  });
  return data;
}
